import type { FunctionComponent } from 'react'
import { useState } from 'react'
import styled from 'styled-components'
import {
  Button,
  FeedbackLink,
  PrivacyLink,
  StyledFooter,
  StyledFooterBottom,
  StyledFooterTop,
  StyledIcon,
  StyledParagraph,
  StyledRow as Row,
} from './styles'
import {
  FOOTER_LINK_PRIVACY,
  FOOTER_LINKS_COLOFON,
  FOOTER_LINKS_HELP,
  FOOTER_LINKS_NEWSLETTER,
  FOOTER_LINKS_SOCIAL,
} from '../../config/content-links'
import FeedbackIcon from '../../assets/icons/feedback.svg'
import FooterLinks from './FooterLinks'
import FeedbackModal from '../Modal/FeedbackModal'
import { Variant } from '../Links/Link/Link'
import ListItem from '../List/ListItem'
import FooterSection from './FooterSection'
import Column from '../Column/Column'

export const FOOTER_ID = 'footer'

const StyledColumn = styled(Column)`
  width: 100%;
  @media only screen and (min-width: 75rem) {
    max-width: calc(33.33% - 1rem);
  }
`

const StyledRow = styled(Row)`
  gap: 1rem;
`

const Footer: FunctionComponent = () => {
  const [openFeedbackModal, setOpenFeedbackModal] = useState(false)
  return (
    <>
      <FeedbackModal setOpen={setOpenFeedbackModal} open={openFeedbackModal} />
      <StyledFooter id={FOOTER_ID}>
        <StyledFooterTop>
          <StyledRow>
            <StyledColumn data-testid="footerQuestions">
              <FooterSection title="Vragen">
                <StyledParagraph>
                  Heeft u een vraag en kunt u het antwoord niet vinden op deze website? Of heeft u
                  bevindingen? Neem dan contact met ons op.
                </StyledParagraph>
                <FooterLinks links={FOOTER_LINKS_HELP}>
                  <ListItem>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <FeedbackLink
                      forwardedAs={Button}
                      variant={Variant.Inline}
                      onClick={() => {
                        setOpenFeedbackModal(true)
                      }}
                    >
                      <StyledIcon>
                        <FeedbackIcon />
                      </StyledIcon>
                      <span>Feedback geven</span>
                    </FeedbackLink>
                  </ListItem>
                </FooterLinks>
              </FooterSection>
            </StyledColumn>
            <StyledColumn data-testid="footerColofon">
              <FooterSection title="Colofon">
                <FooterLinks links={FOOTER_LINKS_COLOFON} />
              </FooterSection>
            </StyledColumn>
            <StyledColumn data-testid="footerFollowUs">
              <FooterSection title="Volg ons">
                <FooterLinks links={FOOTER_LINKS_SOCIAL} isRow />
                <FooterLinks links={FOOTER_LINKS_NEWSLETTER} />
              </FooterSection>
            </StyledColumn>
          </StyledRow>
        </StyledFooterTop>
        <StyledFooterBottom>
          <StyledRow>
            <PrivacyLink
              data-testid={FOOTER_LINK_PRIVACY.testId}
              href={FOOTER_LINK_PRIVACY.href}
              variant={Variant.Inline}
            >
              {FOOTER_LINK_PRIVACY.title}
            </PrivacyLink>
          </StyledRow>
        </StyledFooterBottom>
      </StyledFooter>
    </>
  )
}

export default Footer
